"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withApiContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = _interopRequireDefault(require("@lt/api"));

var _apiContext = require("../apiContext/apiContext");

var _api2 = require("../../utils/api");

var _excluded = ["apiKey", "baseUrl"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withApiContext = function withApiContext(WrappedComponent) {
  var WithApiContextComponent = function WithApiContextComponent(_ref) {
    var customApiKey = _ref.apiKey,
        customBaseUrl = _ref.baseUrl,
        restProps = _objectWithoutProperties(_ref, _excluded);

    // Используем переданные apiKey и baseUrl, если они есть, иначе — значения по умолчанию
    var apiKey = customApiKey || _api2.safetyPartnerKey;
    var apiBaseUrl = customBaseUrl || _api2.baseUrl || 'https://api.level.travel';
    var client = (0, _react.useMemo)(function () {
      if (!apiKey) {
        console.log('Не найден ключ партнера');
        return;
      }

      return new _api["default"]({
        key: apiKey,
        baseURL: apiBaseUrl
      });
    }, [apiKey, apiBaseUrl]); // Передаем клиент API через контекст и рендерим обернутый компонент

    return /*#__PURE__*/_react["default"].createElement(_apiContext.apiContext.Provider, {
      value: {
        api: client
      }
    }, /*#__PURE__*/(0, _react.createElement)(WrappedComponent, restProps));
  };

  WithApiContextComponent.dispayName = 'withApiContext';
  return WithApiContextComponent;
};

exports.withApiContext = withApiContext;